export default '/pricing/yuno';
